import { Injectable, inject } from '@angular/core';
import { TwcRefreshLayerPluginService } from '../../../twc.refresh-layer-plugin.service';
import { GLOBAL_IR_SATELLITE_RADAR_LEGEND } from './global-ir-satellite-radar.legend';
import { GLOBAL_IR_SATELLITE_RADAR_PRODUCT_DATA } from './global-ir-satellite-radar.twc-product-data';

@Injectable({
  providedIn: 'root'
})
export class GlobalIRSatelliteRadarPluginService {
  private _twcPluginService = inject(TwcRefreshLayerPluginService);

  plugin$ = this._twcPluginService.create(
    GLOBAL_IR_SATELLITE_RADAR_PRODUCT_DATA,
    {
      legend: GLOBAL_IR_SATELLITE_RADAR_LEGEND,
      twcLayerTypes: ['web-tile']
    }
  );
}
